import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { ButtonV2 } from '@zola/zola-ui';

// Components
import FileInputButton from '../../form/FileInputButton';

// Images / icons
import faqIcon from '../../../../assets/images/guestlist/faq.svg';

class UploadSpreadsheet extends Component {
  constructor(props) {
    super(props);

    this.processError = this.processError.bind(this);
    this.checkCsvFormat = this.checkCsvFormat.bind(this);

    this.state = {
      error: undefined,
      fileInputKey: 1,
    };
  }

  processError(error) {
    let errorMessage;
    if (error.category && error.category.domain === 'bulk-import') {
      switch (error.category.reason) {
        case 'unknown-column':
          errorMessage = `Your file contains an unknown column. Please remove ${error.trigger}, and try again. Use the Zola provided .csv spreadsheet column names.`;
          break;
        case 'missing-column':
          errorMessage = `Your file contains a missing column. Please add ${error.trigger}, and try again. Use the Zola provided .csv spreadsheet column names.`;
          break;
        case 'primary-name-missing':
          errorMessage = `You are missing a First Name or Last Name in row ${_.toInteger(error.trigger) + 1}. Please add the guest’s name, and try again.`;
          break;
        case 'illegal-characters':
          errorMessage = `Row ${_.toInteger(error.trigger) + 1} contains "[];<>{}\\". Please remove, and try again.`;
          break;
        case 'row-length':
          errorMessage = `Row ${_.toInteger(error.trigger) + 1} contains too many columns. Please use the Zola provided .csv spreadsheet columns and do not add text beyond those columns.`;
          break;
        case 'wrong-file-type':
          errorMessage = 'Please use the Zola provided .csv spreadsheet to import your guest list.  Make sure to save your file as a .csv.';
          break;
        case 'extra-column':
          errorMessage = 'Your file contains a blank column. Please use the Zola provided .csv spreadsheet columns and do not add text beyond those columns.';
          break;
        case 'parsing-failed':
        default:
          errorMessage = 'There was an error uploading your file. Please use the Zola provided .csv spreadsheet column names and try again.';
      }
    } else {
      errorMessage = 'There was an error uploading your file. Please use the Zola provided .csv spreadsheet column names and try again.';
    }

    this.setState({
      error: errorMessage,
      fileInputKey: this.state.fileInputKey + 1
    });
  }

  checkCsvFormat(file, guestsInGuestList) {
    const { onFileCheck } = this.props;
    return onFileCheck(file, guestsInGuestList)
      .catch(error => error.response.json().then(this.processError));
  }

  render() {
    const { error, fileInputKey } = this.state;
    const { guestsInGuestList, callback } = this.props;
    return (
      <div>
        <div className="add-guest-tab upload-spreadsheet">
          <h3 className="tab__title">Upload a Spreadsheet</h3>
          <p className="tab__description add-guest-tab-description">
            Download the empty template and add your guests&#39; information.<br />
            <em>Do not add, edit, or delete</em> columns on the template or it will not upload.<br />
            When finished, save as a .csv and upload it here.
          </p>
          <p className="text-danger margin-top-2x">{error}</p>
          {error && (
            <p className="text-danger margin-top-2x">{error}</p>
          )}
          <div className="tab__buttons">
            <ButtonV2 variant="secondary" role="link" href="/weddings-files/zola_guest_list_template.csv" component="a">Download Empty Template</ButtonV2>
            <FileInputButton
              key={fileInputKey}
              btnClass="btn-primary btn-right"
              inputId="csv_upload"
              types="text/csv"
              onSelect={file => this.checkCsvFormat(file, guestsInGuestList)}
              btnText="Upload Spreadsheet"
              onCheckDuplicates={this.checkDuplicates}
              callback={callback}
            />
          </div>
          <div className="tab__help clearfix">
            <div className="help__icon"><img src={faqIcon} alt="faq icon" /></div>
            <div className="help__text">
              <p className="help__cta">Need Help?</p>
              <p>Visit our <a href="https://help.zola.com/hc/articles/115002148812-How-do-I-use-the-guest-list-import-tool" className="text-button" target="_blank" rel="noopener noreferrer">FAQ page</a> for more details on how to fill out the spreadsheet.</p>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

UploadSpreadsheet.propTypes = {
  onFileCheck: PropTypes.func,
  guestsInGuestList: PropTypes.arrayOf(
    PropTypes.number
  ),
  callback: PropTypes.func,
};

export default UploadSpreadsheet;



// WEBPACK FOOTER //
// ./src/components/common/modals/AddGuestGroupModal/UploadSpreadsheet.jsx